var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataVisualization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 130,
    viewBox: "0 0 132 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Data visualization",
    filter: "url(#filter0_d_90_630)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_802_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_51_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_562_",
    d: "M29.125 71.5547H31.0156V73.4297H29.125V71.5547Z",
    fill: "#0EA5E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_563_",
    d: "M32.875 71.5547H34.7656V73.4297H32.875V71.5547Z",
    fill: "#0EA5E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_787_",
    d: "M36.625 71.5547H38.5156V73.4297H36.625V71.5547Z",
    fill: "#0EA5E9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_731_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1226_",
    d: "M35.4584 34.0481V35.9231H86.125V67.1722H25.875V35.9231H33.6041V34.0481H24V77.3283H47.0924L45.7246 85.7959H37.4654V95.9519H63.5V94.0769H39.3404V87.6709H72.6425V94.0769H65.375V95.9519H74.5175V85.7959H66.2583L64.8905 77.3283H88V34.0481H35.4584ZM64.3589 85.7959H47.6239L48.9916 77.3283H62.9911L64.3589 85.7959ZM86.125 75.4533H25.875V69.0471H86.125V75.4533Z",
    fill: "#0EA5E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1841_",
    d: "M65.1778 44.0358C65.1398 43.9894 65.1006 43.9443 65.062 43.8985L64.5409 43.3195C62.3098 41.0005 59.2475 39.6875 56 39.6875C49.665 39.6875 44.474 44.6803 44.1554 50.9375L44.1455 51.9026V51.9029L44.172 52.8125C44.4626 55.5597 45.7296 58.1027 47.7314 60.05C49.956 62.2137 52.89 63.406 56 63.4075V63.4077H56.0378L56.9443 63.3706C63.0443 62.888 67.86 57.7698 67.86 51.5478C67.86 49.124 67.1075 46.7512 65.7284 44.7711L65.1778 44.0358ZM56 41.5625C58.6971 41.5625 61.2429 42.638 63.1149 44.5417L55.6533 50.9375H46.0334C46.3499 45.7149 50.6991 41.5625 56 41.5625ZM46.0936 52.8125H55.0631L55.0683 61.4907C50.3891 61.0659 46.6721 57.469 46.0936 52.8125ZM64.2978 45.9974C65.3913 47.6324 65.9851 49.5702 65.9851 51.5476C65.9851 56.7355 62.0086 61.012 56.9433 61.4885L56.9378 52.3059L64.2978 45.9974Z",
    fill: "#0EA5E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1844_",
    d: "M71.1523 50.6101H78.7226V52.4851H71.1523V50.6101Z",
    fill: "#0EA5E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1845_",
    d: "M80.5977 50.6101H82.4727V52.4851H80.5977V50.6101Z",
    fill: "#0EA5E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1846_",
    d: "M33.2773 50.6101H40.8476V52.4851H33.2773V50.6101Z",
    fill: "#0EA5E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1847_",
    d: "M29.5273 50.6101H31.4023V52.4851H29.5273V50.6101Z",
    fill: "#0EA5E9"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_90_630",
    x: 0,
    y: -1,
    width: 132,
    height: 132,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.219608 0 0 0 0 0.741176 0 0 0 0 0.972549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_90_630"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_90_630",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataVisualization);
export default __webpack_public_path__ + "static/media/Data_visualization.e46b0fccfe335b17321fc5cf2342e40d.svg";
export { ForwardRef as ReactComponent };